import type { RowProps } from 'antd';
import { useResolveSpacingValue } from '../../hooks';

type GutterValue = RowProps['gutter'];
type SingleGutterValue = Exclude<GutterValue, readonly unknown[]>;

export const useGetGutter = ({ gutter }: { gutter?: GutterValue }): GutterValue => {
  const resolveSpacingValue = useResolveSpacingValue();

  if (!gutter) {
    return undefined;
  }

  const resolve = (value: SingleGutterValue): SingleGutterValue => {
    if (typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, entryValue]) => [key, resolveSpacingValue({ value: entryValue })]),
      );
    }

    return resolveSpacingValue({ value });
  };

  return Array.isArray(gutter) ? [resolve(gutter[0]), resolve(gutter[1])] : resolve(gutter);
};
